import type { ChoiceProps } from '@/components/control/components/choice/choice.types';
import { Check } from 'lucide-react';
import clsx from 'clsx';
import '@/components/control/components/choice/choice.css';

export default function Choice(props: ChoiceProps) {
  const { type, checked, focused = false, hovered = false, state = 'idle', disabled = false } = props;
  return (
    <div
      className={clsx('control-choice', {
        'control-choice--checked': checked,
        'control-choice--focused': focused,
        'control-choice--hovered': hovered,
        'control-choice--disabled': disabled,
        'control-choice--radio': type === 'radio',
        'control-choice--checkbox': type === 'checkbox',
        'control-choice--idle': state === 'idle',
        'control-choice--error': state === 'error',
        'control-choice--success': state === 'success' || checked,
      })}
    >
      {type === 'radio' && <div className='control-choice__mark' />}
      {type === 'checkbox' && <Check className='control-choice__mark' />}
    </div>
  );
}
